import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

// Product List Components
import Cart0 from "./Cart0";
import Cart1 from "./Cart1";
import Cart2 from "./Cart2";

const Cart = () => {
  const [cartNo, setCartNo] = useState(null);
  const [data, setData] = useState([]);
  const userPincode = sessionStorage.getItem("userPincode");

 
  const user_auto_id = sessionStorage.getItem("accessToken")

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setCartNo(parseInt(parsedStyle.cart_layout_no));
    }
  }, []);

   const fetchCartList = async () => {
     try {
       setData([]);
       const formData = new FormData();
       formData.append("user_auto_id", user_auto_id);
       formData.append(
         "admin_auto_id",
         sessionStorage.getItem("admin_auto_id")
       );
       formData.append("limit", "10");
       formData.append("page_number", "1");
       formData.append("app_type_id", sessionStorage.getItem("app_type_id"));
       formData.append("pincode", userPincode);

       const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_list`,
         formData
       );

       if (response.data.status === 1) {
         const { status, ...restData } = response.data;
         setData(restData);
       }
     } catch (error) {
       console.error("Error fetching products:", error);
     }
   };

//    useEffect(() => {
//   const storedStyle = sessionStorage.getItem("UIStyle");

//   if (storedStyle) {
//     const parsedStyle = JSON.parse(storedStyle);
//     setCartNo(parseInt(parsedStyle.cart_layout_no));
//   }

//   // 🔥 TEMPORARY OVERRIDE FOR TESTING
//   setCartNo(0);   // ← Change this (0, 1, or 2)
// }, []);


  useEffect(() => {
    fetchCartList();
  }, [user_auto_id]);

  // Mapping cartNo to Components
  const cartComponents = {
    0: Cart0,
    1: Cart0,
    2: Cart0,
  };

  const SelectedCart = cartComponents[cartNo];

  return (
    <div>
      {SelectedCart && (
        <SelectedCart data={data} fetchCartList={fetchCartList} />
      )}
    </div>
  );
};

export default Cart;
